var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoldedHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0284 26.6667V21.6667L24.084 16.1806C23.2692 16.4769 22.6303 16.9908 22.1673 17.7223C21.7043 18.4538 21.4729 19.2593 21.4729 20.139V31.9167L24.3757 36.6667H37.1673L35.5007 15.9722L23.8895 2.52783L23.709 2.70837C22.7923 3.62504 22.2344 4.69911 22.0354 5.93058C21.8363 7.16208 22.0423 8.33801 22.6534 9.45837L28.9729 21.1112V26.6667H27.0284ZM12.0284 26.6667V21.1112L18.3479 9.45837C18.959 8.35654 19.1557 7.18525 18.9382 5.9445C18.7206 4.70375 18.1673 3.62504 17.2784 2.70837L17.1118 2.52783L5.50065 15.9722L3.83398 36.6667H16.6257L19.5284 31.9167V20.139C19.5284 19.2593 19.2946 18.4538 18.827 17.7223C18.3594 16.9908 17.7229 16.4769 16.9173 16.1806L13.9729 21.6667V26.6667H12.0284Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldedHands);
export default __webpack_public_path__ + "static/media/folded_hands.05437fa6.svg";
export { ForwardRef as ReactComponent };